import React, { useMemo } from "react"

import Button from "../../../../design-system/button"
import Stack from "../../../../design-system/stack"
import useBreakpoint from "../../../../utils/hooks/use-breakpoint"
import { CaseStudyPageContext } from "../../types"
import CaseStudyHighlights from "../case-study-highlights"
import CaseStudyMetadata from "../case-study-metadata"
import * as styles from "./index.module.scss"

function CaseStudySidebar({
  sidebarText1,
  sidebarText1Details,
  sidebarText2,
  sidebarText2Details,
  sidebarText3,
  sidebarText3Details,
  ...rest
}: CaseStudyPageContext) {
  const { isMediumBreakpoint } = useBreakpoint()
  const highlights = useMemo(
    () =>
      [
        {
          title: sidebarText1,
          details: sidebarText1Details,
        },
        {
          title: sidebarText2,
          details: sidebarText2Details,
        },
        {
          title: sidebarText3,
          details: sidebarText3Details,
        },
      ].filter(({ title, details }) => !!title || !!details),
    [
      sidebarText1,
      sidebarText1Details,
      sidebarText2,
      sidebarText2Details,
      sidebarText3,
      sidebarText3Details,
    ],
  )

  const highlightsNode = !!highlights.length && (
    <CaseStudyHighlights texts={highlights} />
  )

  return (
    <div className={styles.rightColumn}>
      {isMediumBreakpoint && highlightsNode}
      <CaseStudyMetadata {...rest} />
      <div className={styles.stickyColumn}>
        <Stack spacing={40}>
          {!isMediumBreakpoint && highlightsNode}
          <Stack spacing={16}>
            <span className={styles.centralized}>Ready to get started?</span>
            <Button fullWidth as="a" href="/demo">
              Contact sales
            </Button>
          </Stack>
        </Stack>
      </div>
    </div>
  )
}

export default CaseStudySidebar
